(function ($) {

'use strict';

	/**
	 * Loads the jquery.lightbox_me.js if required and execute the done function
	 * when ready
	 * @param {function} doneFunc
	 * @returns {undefined}
	 */
	$.loadSweetalertJs = function (doneFunc) {

		/**
		 * check if the doneFunc could run
		 */
		function loadedNow() {
			if (!$.loadSweetalertActive) {
				doneFunc();
			} else {
				setTimeout(loadedNow, 100);
			}
		}

		if (typeof $.fn.swal !== 'function' && !$.loadSweetalertActive) {
			// set loading status
			$.loadSweetalertActive = true;
			// try to load sweetalert2.all.min.js
			var jsFile = '/js/sweetalert2/sweetalert2.all.min.js';
			$.cachedScript(jsFile).done(function () {
				// clear loading status

				delete $.loadSweetalertActive;
				
				if (typeof doneFunc === 'function') {
					loadedNow();
				}	
			}).fail(function (jqxhr, settings, exception) {
				console.log(jsFile + ' ! ' + exception);
			});
		} else if (typeof doneFunc === 'function') {
			loadedNow();
		}
	};	// $.loadLightboxJs

}(jQuery));